import React, { useEffect, useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/gui-custom-datepicker.scss";

const GuiCustomDatepickerDropdown = ({
  dateLabel,
  onDateChange,
  dateSelected,
  disabled,
  minDate,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const datePickerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(
    dateSelected ? new Date(dateSelected) : null,
  );

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const dateElements = document.querySelectorAll(
          ".react-datepicker__day--range-end, .react-datepicker__day--range-start, .react-datepicker__day--in-range",
        );
        dateElements.forEach((element) => {
          let date = element.getAttribute("aria-label").split(" ")[3]; // Extract the date
          let dateNumber = date.match(/\d+/)[0];
          element.dataset.date = dateNumber; // Set the date as a data attribute
        });
      }, 0);
    }
  }, [isOpen]);

  const handleDateChange = (value) => {
    // Get local date (Year, Month, Day only) to prevent timezone shifts
    const localDate = new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
    );

    // If it's a START DATE, explicitly set time to 00:00:00
    if (dateLabel === "From Date") {
      localDate.setHours(0, 0, 0, 0);
    }

    // If it's an END DATE, explicitly set time to 23:59:59 to include full-day entries
    if (dateLabel === "To Date") {
      localDate.setHours(23, 59, 59, 999);
    }

    setSelectedDate(localDate);
    onDateChange(localDate.toISOString()); // Keep full ISO format for accuracy
    setIsOpen(false);
  };

  const CustomHeader = ({
    date,
    changeMonth,
    changeYear,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div className="custom-datepicker-header">
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        className="custom-nav-button prev-button"
        type="button"
      >
        &lt;
      </button>
      <span className="month-year-label">
        {date.toLocaleString("en-US", { month: "long", year: "numeric" })}
      </span>
      <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        className="custom-nav-button next-button"
        type="button"
      >
        &gt;
      </button>
    </div>
  );

  return (
    <div className="single-datepicker-dropdown-container">
      <label className={`single-datepicker-label`}>{dateLabel}</label>

      <Dropdown
        ref={dropdownRef}
        onToggle={(isOpen) => {
          setIsOpen(isOpen);
        }}
        show={isOpen}
      >
        <Dropdown.Toggle
          variant="success"
          className={`dropdown-toggle-datepicker`}
          disabled={disabled}
        >
          {selectedDate ? selectedDate.toLocaleDateString() : "MM/DD/YYYY"}
          <i className="fa fa-calendar"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="dropdown-container single-datepicker">
            <DatePicker
              ref={datePickerRef}
              selected={selectedDate}
              onChange={handleDateChange}
              inline
              disabledKeyboardNavigation
              minDate={minDate}
              renderCustomHeader={CustomHeader}
            />
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default GuiCustomDatepickerDropdown;
